import React, {forwardRef, useEffect, useLayoutEffect, useState} from "react";
import {IconDropdownSelected} from "../../../../../src/Icon";
import {postMessage} from "../../../../../src/common/event";
import {EVENT_SHOW_FONT_CHOOSE} from "../../../../../src/Const";
import {
    generateUUID2,
    getImagePathWithTheme,
    hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix
} from "../../../../../src/utils";
import {getFormValue} from "../../actions/actionProperties";
import {isTextElement} from "../../element";
import {getBoundTextElement} from "../../element/textElement";
import {DEFAULT_FONT_FAMILY, FONT_FAMILY} from "../../constants";
import { Select } from "antd";
import Global from "../../../../../src/global";
import i18next from "i18next";
import {getFontFamilyString} from "../../utils";

const ChooseFont = forwardRef((props:{onFontFamilyChange:any,defaultFontFamily:any,dropDownWidth?:any}, ref) => {
    const [isOpenSelect,setIsOpenSelect] = useState(false);
    const [fontFamilyValue,setFontFamilyValue] = useState('Open sans');
    const [fontFamilyIntValue,setFontFamilyIntValue] = useState(1);

    let arrayCustomFonts:any[] = [];
    for (let i=0;i<Global.g_arrayFonts.length;i++){
        const font = Global.g_arrayFonts[i];
        let item = { value: font.fontName,shortName:font.shortName, label:font.fontName ,showLabel:<span className='align-left' style={{fontFamily:font.fontName,whiteSpace:'nowrap',width:'126px',overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{font.fontName}</span>};
        arrayCustomFonts.push(item);
        FONT_FAMILY[font.fontName] = font.fontName;
    }

    //Virgil
    let arrayDefaultFonts =  [
        { value: FONT_FAMILY.OpenSans, label: 'OpenSans', familyName:'', showLabel:<span className='align-left' style={{fontFamily:"OpenSans"}}>OpenSans</span>},
        { value: FONT_FAMILY.Helvetica, label: 'Helvetica' ,familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Helvetica"}}>Helvetica</span>},
        { value: FONT_FAMILY.Cascadia, label: 'Cascadia',familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Cascadia"}}>Cascadia</span> },
        // {value: FONT_FAMILY.Sparky,label: "Sparky"},
        // {value: FONT_FAMILY.Delight,label: "Delight"},
        // {value: FONT_FAMILY.HoneySilk,label: "HoneySilk"},
        // {value: FONT_FAMILY.Netigen,label: "Netigen"},
        // {value: FONT_FAMILY.Playfulist,label: "Playfulist"},
        // {value: FONT_FAMILY.WigglyCurves,label: "WigglyCurves"},
        {value: FONT_FAMILY.Winter,label: "Winter",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Winter"}}>Winter</span>},
        // {value: FONT_FAMILY.YeastyFlavors,label: "YeastyFlavors"},
        // {value: FONT_FAMILY.MUMMY_S,label: "MUMMY_S"},
        {value: FONT_FAMILY.Dufanthe,label: "Dufanthe",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Dufanthe"}}>Dufanthe</span>},
        // {value: FONT_FAMILY.PacifyAngry,label: "PacifyAngry"},
        {value: FONT_FAMILY.WinterCoffee,label: "WinterCoffee",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"WinterCoffee"}}>WinterCoffee</span>},
        {value: FONT_FAMILY.Pacifico,label: "Pacifico",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Pacifico"}}>Pacifico</span>},
        // {value: FONT_FAMILY.MilkyCoffee,label: "MilkyCoffee"},
        {value: FONT_FAMILY.Gagalin,label: "Gagalin",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Gagalin"}}>Gagalin</span>},
        {value: FONT_FAMILY.AreaKilometer,label: "AreaKilometer",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"AreaKilometer"}}>AreaKilometer</span>},
        // {value: FONT_FAMILY.Anggota,label: "Anggota"},
        {value: FONT_FAMILY.CallOfOpsDuty,label: "CallOfOpsDuty",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"CallOfOpsDuty"}}>CallOfOpsDuty</span>},
        // {value: FONT_FAMILY.BlankNote,label: "BlankNote"},
        {value: FONT_FAMILY.Tropikal,label: "Tropikal",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Tropikal"}}>Tropikal</span>},
        // {value: FONT_FAMILY.MuyaoPleased,label: "MuyaoPleased"},
        // {value: FONT_FAMILY.Loftygoals,label: "Loftygoals"},
        // {value: FONT_FAMILY.NotesSans,label: "NotesSans"},
        {value: FONT_FAMILY.SAF,label: "SAF",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"SAF"}}>SAF</span>},
        {value: FONT_FAMILY.Inter,label: "Inter",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Inter"}}>Inter</span>},
        {value: FONT_FAMILY.Poppins,label: "Poppins",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Poppins"}}>Poppins</span>},
        {value: FONT_FAMILY.Roboto,label: "Roboto",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Roboto"}}>Roboto</span>},
        {value: FONT_FAMILY.MontaguSlab,label: "MontaguSlab",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"MontaguSlab"}}>MontaguSlab</span>},
        {value: FONT_FAMILY.Lora,label: "Lora",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"Lora"}}>Lora</span>},
        {value: FONT_FAMILY.RobotoMono,label: "RobotoMono",familyName:'',showLabel:<span className='align-left' style={{fontFamily:"RobotoMono"}}>RobotoMono</span>}
    ]
    for (let i=0;i<arrayDefaultFonts.length;i++){
        let item:any = arrayDefaultFonts[i];
        item.showLabel = <span className='align-left' style={{fontFamily:item.label,whiteSpace:'nowrap',width:'100%',overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{item.label}</span>
    }

    let arrayOptions:any = arrayDefaultFonts;

    if (arrayCustomFonts.length > 0){
        arrayOptions = [
            {
                label: <span>Custom Fonts</span>,
                title: 'custom',
                options:arrayCustomFonts
            },
            {
                label: <span>Default Fonts</span>,
                title: 'default',
                options:arrayDefaultFonts
            }
        ]
    }

    useEffect(() => {
        if (props.defaultFontFamily){
            const arraySplits = props.defaultFontFamily.split(',');
            setFontFamilyValue(arraySplits[0]);
            const font = arrayDefaultFonts.find(p=>p.label == arraySplits[0]);
            if (font){
                setFontFamilyIntValue(font.value);
            }
        }else{
            setFontFamilyValue('Open sans');
            setFontFamilyIntValue(1);
        }
    }, [props.defaultFontFamily]);

    useEffect(() => {
        Global.g_isFontSelectedOpend = isOpenSelect;
    }, [isOpenSelect]);


    const updateData = (fontFamilyValue:any)=>{
        const szFontFamily = getFontFamilyString({fontFamily:fontFamilyValue});
        setFontFamilyValue(szFontFamily);
        setFontFamilyIntValue(fontFamilyValue);
        props.onFontFamilyChange(szFontFamily);
    }


    //下拉渲染...
    const renderDropdown = ()=>{
        if (arrayCustomFonts.length == 0){
            return arrayDefaultFonts.map(p=>
                <div className='flex-row-vertical-center dropdown-item' key={p.value} onMouseDown={(e)=>{
                    e.stopPropagation();
                    updateData(p.value);
                    setIsOpenSelect(false)
                }}>
                    <img style={{opacity:(fontFamilyValue == p.label)?'1':"0"}} className='img-14 mr-10 ml-10' src={getImagePathWithTheme('check_black')}/>
                    {p.showLabel}
                </div>
            )
        }else{
            return(
                <div>
                    {
                        arrayOptions.map((item: any) => {
                            return (
                                <div key={generateUUID2()}  style={{margin:'4px 0 6px 0'}}>
                                    {
                                        <div className='ml-10 font-family-medium' style={{color:'#96A0B5',fontSize:'14px'}}>{item.label}</div>
                                    }
                                    {
                                        item.options.map((p: any) => {
                                            return (
                                                <div key={generateUUID2()} className='flex-row-vertical-center dropdown-item' onMouseDown={(e)=>{
                                                    e.stopPropagation();
                                                    updateData(p.value);
                                                    setIsOpenSelect(false)
                                                }}>
                                                    <img style={{opacity: (fontFamilyValue == p.label) ? '1' : "0"}}
                                                         className='img-14 mr-10 ml-10' src={getImagePathWithTheme('check_black')}/>
                                                    {p.showLabel}
                                                </div>)
                                        })
                                    }
                                    <div style={{width: '120%', margin: '6px -16px 10px -16px',borderBottom:'1px solid var(--font-line-color)'}}></div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
    }

    return<>
        <Select
            open={isOpenSelect}
            onDropdownVisibleChange={(e) => {
                setIsOpenSelect(e);

            }}
            className='hovered-border extendview-choosefont'
            variant={"borderless"}
            suffixIcon={<img className='img-mini-small-10' src={getImagePathWithTheme('drop_down_select')} onClick={(e)=>{
                setIsOpenSelect(true)
            }}/>}
            dropdownStyle={{width: props.dropDownWidth || '187px',border:'1px solid var(--border-color)'}}
            style={{
                minWidth:'100%',
                height:'30px',
                fontSize:'12px',
                borderRadius:'8px',
                border:'0px solid var(--input-border-color)',
            }}
            options={arrayOptions}
            onChange={(key)=>{

            }}
            dropdownRender={(menu)=>(
                <div id={'selectFontFamily'} style={{display:"flex",flexDirection:'column',height:'320px',overflowX:'hidden',overflowY:'auto'}}>
                    {
                        renderDropdown()
                    }
                    {/*<div className='flex-column-center'>*/}
                    {/*    <div className='flex-center mt-10 mb-12 hovered' style={{minWidth: '106px',height:'30px',position:'relative',border:'1px solid var(--import-font-border-color)',borderRadius:'8px'}} onClick={()=>{*/}
                    {/*        setIsOpenSelect(false);*/}
                    {/*        postMessage(EVENT_SHOW_FONT_CHOOSE);*/}
                    {/*    }}>*/}
                    {/*        <span>{i18next.t("Import font")}</span>*/}
                    {/*        {*/}
                    {/*            !hasLicense() && !hasDesktopBaseLicense() &&*/}
                    {/*            <img className='img-18' style={{position: 'absolute', right: '-8px', top: '-10px'}}*/}
                    {/*                 src={imgPathPerfix() + 'vip.png'}/>*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                </div>
            )}
            // optionRender={(oriOption, info) =>
            //     <div className='flex-row-vertical-center'>
            //         <img className='img-mini-small-12 filter-img-white' src={imgPathPerfix()+
            //             ( fontFamilyValue == oriOption.label ? 'check_black.png':'transparent.png')
            //         }/>
            //         <span className='ml-8' style={{fontFamily: (oriOption.data.shortName != undefined)?oriOption.data.shortName:oriOption.label}}>{oriOption.label}</span>
            //     </div>
            // }
            optionLabelProp={'showLabel'}
            value={fontFamilyIntValue}
        />
    </>
})

export default ChooseFont;